/* ============================================================
   AURMILA — tema Shopify
   Carrello AJAX, pannelli, selettore varianti, animazioni.
   ============================================================ */
(function () {
  'use strict';

  var motoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function host() { return document.getElementById('carrello-host'); }
  function cassetto() { return document.querySelector('[data-pannello="carrello"]'); }

  /* ---------- Pannelli (carrello e menu) ---------- */
  function apri(pannello) {
    if (!pannello) return;
    pannello.dataset.aperto = 'true';
    var velo = document.querySelector('[data-velo]');
    if (velo) velo.setAttribute('data-aperto', 'true');
    document.body.style.overflow = 'hidden';
    var f = pannello.querySelector('button, a');
    if (f) f.focus();
  }

  function chiudiTutto() {
    var pannelli = document.querySelectorAll('[data-pannello]');
    for (var i = 0; i < pannelli.length; i++) pannelli[i].dataset.aperto = 'false';
    var velo = document.querySelector('[data-velo]');
    if (velo) velo.setAttribute('data-aperto', 'false');
    document.body.style.overflow = '';
  }

  /* ---------- Ricarica il carrello dal server ---------- */
  function ricaricaCarrello(apriDopo) {
    return fetch(window.location.pathname + '?section_id=carrello')
      .then(function (r) {
        if (!r.ok) throw new Error('sezione non disponibile');
        return r.text();
      })
      .then(function (html) {
        var h = host();
        if (!h) return;
        h.innerHTML = html;
        aggiornaPallino();
        if (apriDopo) apri(cassetto());
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function aggiornaPallino() {
    var sorgente = document.querySelector('[data-conta-sorgente]');
    if (!sorgente) return;
    var n = parseInt(sorgente.textContent.trim(), 10) || 0;
    var badge = document.querySelectorAll('[data-conta]');
    for (var i = 0; i < badge.length; i++) {
      badge[i].textContent = n;
      badge[i].hidden = n === 0;
    }
  }

  /* ---------- Selettore varianti ---------- */
  function varianti() {
    var tag = document.querySelector('[data-varianti]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function scelteAttuali() {
    var scelte = [];
    var gruppi = document.querySelectorAll('.taglie');
    for (var i = 0; i < gruppi.length; i++) {
      var attivo = gruppi[i].querySelector('[aria-pressed="true"]');
      scelte[i] = attivo ? attivo.dataset.valore : null;
    }
    return scelte;
  }

  function soldi(centesimi) {
    return '€' + (centesimi / 100).toFixed(2).replace('.', ',');
  }

  function aggiornaVariante() {
    var lista = varianti();
    if (!lista) return;

    var scelte = scelteAttuali();
    var trovata = null;
    for (var i = 0; i < lista.length; i++) {
      var ok = true;
      for (var j = 0; j < scelte.length; j++) {
        if (scelte[j] !== null && lista[i].options[j] !== scelte[j]) { ok = false; break; }
      }
      if (ok) { trovata = lista[i]; break; }
    }

    var campoId = document.querySelector('[data-variante-id]');
    var bottone = document.querySelector('[data-aggiungi]');
    var etichetta = document.querySelector('[data-etichetta-aggiungi]');
    var prezzo = document.querySelector('[data-prezzo]');

    if (!trovata) {
      if (bottone) bottone.disabled = true;
      if (etichetta) etichetta.textContent = 'Combinazione non disponibile';
      return;
    }

    if (campoId) campoId.value = trovata.id;
    if (bottone) bottone.disabled = !trovata.available;
    if (etichetta) {
      etichetta.textContent = trovata.available
        ? (bottone && bottone.dataset.etichetta ? bottone.dataset.etichetta : 'Aggiungi al carrello')
        : 'Esaurito';
    }

    if (prezzo && typeof trovata.price === 'number') {
      var html = '';
      if (trovata.compare_at_price && trovata.compare_at_price > trovata.price) {
        html += '<span class="prezzo--vecchio">' + soldi(trovata.compare_at_price) + '</span>';
      }
      html += soldi(trovata.price);
      prezzo.innerHTML = html;
    }

    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', trovata.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- Rivelazioni allo scroll ----------
     Le immagini si scoprono con una tendina, il resto sale sfumando. */
  function rivelazioni() {
    if (motoRidotto || !('IntersectionObserver' in window)) return;

    var conVelo = document.querySelectorAll('.feature__img, .storia__img, .galleria__i');
    var normali = document.querySelectorAll('.sez__testa, .manifesto, .card, .feature__testo, .storia__testo, .valore, .pdp__info, .news');

    var tutti = [];
    var i;
    for (i = 0; i < conVelo.length; i++) {
      if (conVelo[i].dataset.rivelato) continue;
      conVelo[i].dataset.rivelato = '1';
      conVelo[i].classList.add('rivela--velo');
      tutti.push(conVelo[i]);
    }
    for (i = 0; i < normali.length; i++) {
      if (normali[i].dataset.rivelato) continue;
      normali[i].dataset.rivelato = '1';
      normali[i].classList.add('rivela');
      tutti.push(normali[i]);
    }
    if (!tutti.length) return;

    var io = new IntersectionObserver(function (voci, obs) {
      var visibili = [];
      for (var k = 0; k < voci.length; k++) {
        if (voci[k].isIntersecting) visibili.push(voci[k].target);
      }
      for (var n = 0; n < visibili.length; n++) {
        (function (el, ritardo) {
          setTimeout(function () { el.classList.add('visto'); }, ritardo);
        })(visibili[n], n * 70);
        obs.unobserve(visibili[n]);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    for (i = 0; i < tutti.length; i++) io.observe(tutti[i]);
  }

  /* ---------- Intestazione che si ritira allo scroll ---------- */
  function intestazioneDinamica() {
    var testata = document.querySelector('.testata');
    if (!testata || testata.dataset.dinamica) return;
    testata.dataset.dinamica = '1';

    var inCoda = false;
    function calcola() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      testata.classList.toggle('testata--ridotta', y > 90);
      inCoda = false;
    }

    window.addEventListener('scroll', function () {
      if (inCoda) return;
      inCoda = true;
      window.requestAnimationFrame(calcola);
    }, { passive: true });

    calcola();
  }

  /* ---------- Eventi ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-apri-carrello]')) { e.preventDefault(); apri(cassetto()); return; }
    if (t.closest('[data-apri-menu]')) { apri(document.querySelector('[data-pannello="menu"]')); return; }
    if (t.closest('[data-chiudi]') || t.closest('[data-velo]')) { chiudiTutto(); return; }

    var rim = t.closest('[data-rimuovi]');
    if (rim) {
      e.preventDefault();
      rim.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(rim.dataset.rimuovi), quantity: 0 })
      }).then(function () { return ricaricaCarrello(false); })
        .then(function () { apri(cassetto()); });
      return;
    }

    var tg = t.closest('[data-valore]');
    if (tg) {
      var fratelli = tg.parentElement.querySelectorAll('[data-valore]');
      for (var i = 0; i < fratelli.length; i++) {
        fratelli[i].setAttribute('aria-pressed', String(fratelli[i] === tg));
      }
      aggiornaVariante();
      return;
    }

    var q = t.closest('[data-qta]');
    if (q) {
      var out = q.parentElement.querySelector('[data-qta-val]');
      var campo = document.querySelector('[data-qta-campo]');
      var v = Math.max(1, Math.min(9, Number(out.value) + Number(q.dataset.qta)));
      out.value = v;
      out.textContent = v;
      if (campo) campo.value = v;
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') chiudiTutto();
  });

  /* ---------- Aggiunta al carrello senza ricaricare la pagina ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    // ATTENZIONE: non usare form.id per riconoscere il form.
    // L'input <input name="id"> del prodotto maschera la proprietà e
    // restituisce l'elemento invece della stringa. Ci si aggancia all'action.
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();
    var bottone = form.querySelector('[data-aggiungi]');
    var etichetta = form.querySelector('[data-etichetta-aggiungi]');
    var originale = etichetta ? etichetta.textContent.trim() : '';

    if (bottone) bottone.disabled = true;

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, dati: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (etichetta) etichetta.textContent = res.dati.description || 'Non disponibile';
          setTimeout(function () {
            if (etichetta) etichetta.textContent = originale;
            if (bottone) bottone.disabled = false;
          }, 2200);
          return;
        }
        if (etichetta) etichetta.textContent = 'Aggiunto ✓';
        return ricaricaCarrello(true).then(function () {
          setTimeout(function () {
            if (etichetta) etichetta.textContent = originale;
            if (bottone) bottone.disabled = false;
          }, 900);
        });
      })
      .catch(function () { form.submit(); });
  });

  /* ---------- Avvio ---------- */
  function avvio() {
    aggiornaPallino();
    rivelazioni();
    intestazioneDinamica();
    var b = document.querySelector('[data-aggiungi]');
    var e = document.querySelector('[data-etichetta-aggiungi]');
    if (b && e && !b.dataset.etichetta) b.dataset.etichetta = e.textContent.trim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvio);
  } else {
    avvio();
  }

  document.addEventListener('shopify:section:load', avvio);
})();
